<template>
  <section data-component-name="AboutObjectFirst">
    <div class="left">
      <h3 class="title">{{ $t('AboutObjectFirst.left.title') }}</h3>
      <p v-html="$t('AboutObjectFirst.left.description')" class="description" />
    </div>

    <div class="right">
      <strong v-html="$t('AboutObjectFirst.right.title')" class="title" />

      <ul class="social-links">
        <li v-for="{ href, icon } of links" :key="href" class="social-link">
          <NuxtLink :to="href" target="_blank">
            <SvgIcon :name="icon" />
          </NuxtLink>
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
// components
import SvgIcon from '~/components/SvgIcon.vue';

// constants
import { OBJECT_FIRST } from '~/constants';

// composables
import useLocalePathWithSlash from '~/composables/useLocalePathWithSlash';

const localePathWithSlash = useLocalePathWithSlash();

const links = [
  {
    href: localePathWithSlash('/'),
    icon: 'planet',
  },
  {
    href: OBJECT_FIRST.LINK.LINKED_IN,
    icon: 'linked-in',
  },
  {
    href: OBJECT_FIRST.LINK.INSTAGRAM,
    icon: 'instagram',
  },
  {
    href: OBJECT_FIRST.LINK.YOUTUBE,
    icon: 'youtube',
  },
];
</script>

<style scoped lang="scss">
@import '$/mixins/components';
@import '$/mixins/typography';
@import '$/mixins/flex';
@import '$/mixins/size';
@import '$/mixins/media';
@import '$/variables/color-roles';
@import '$/functions/token';

[data-component-name='AboutObjectFirst'] {
  @include flex-stretch-sb;
  border: 1px solid token('outline-tertiary');

  @include tablet {
    flex-direction: column;
  }

  .left,
  .right {
    padding: 2rem;

    @include tablet {
      padding: 1.5rem;
    }

    @include mobile {
      padding: 1.5rem 1rem;
    }
  }

  .left {
    h3.title {
      @include h4;
      margin-bottom: 1rem;
    }

    :deep(p.description) {
      @include body-2;

      a {
        @include app-link;
        font-size: inherit;
        line-height: inherit;
      }
    }
  }

  .right {
    @include fixed-width(24rem);
    background-color: map-get($neutral, 'Gray-98');

    @include tablet {
      @include fixed-width(100%);
    }

    :deep(strong.title) {
      @include subtitle-1;

      display: block;
      margin-bottom: 2rem;

      br {
        @include tablet {
          display: none;
        }
      }
    }

    ul.social-links {
      @include flex-center-start;
      gap: 0 1rem;

      li.social-link {
        a {
          display: flex;

          svg {
            @include fixed-size(2.5rem);
            fill: token('surf-cont-secon-action');
          }
        }
      }
    }
  }
}
</style>
